import * as z from "zod/v4";

/**
 * Validation issue schema - represents a single validation problem found.
 */
export const validationIssueSchema = z.object({
  code: z.string(),
  message: z.string(),
  severity: z.enum(["warning", "error"]),
  suggestion: z.string().optional(),
  affectedRateTableId: z.string().optional(),
  affectedRateTableName: z.string().optional(),
});

/**
 * Response type for operations that may have validation issues.
 * Either success (true) or validation issues that need to be addressed.
 */
export const validationResponseSchema = z.union([
  z.object({ success: z.literal(true) }),
  z.object({
    success: z.literal(false),
    validationIssues: z.object({
      warnings: z.array(validationIssueSchema),
      errors: z.array(validationIssueSchema),
    }),
  }),
]);

export type ValidationIssue = z.infer<typeof validationIssueSchema>;
export type ValidationResponse = z.infer<typeof validationResponseSchema>;
